import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFuturelearnComponent } from './simple-icons-futurelearn.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFuturelearnComponent ],
    exports:      [ SimpleIconsFuturelearnComponent ],
    bootstrap:    []
})
export class SimpleIconsFuturelearnModule {}
